<template>
  <!-- Global notification live region, render this permanently at the end of the document -->
  <div
    aria-live="assertive"
    class="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
  >
    <div class="flex flex-col items-center w-full space-y-4 sm:items-end">
      <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
      <transition
        enter-active-class="transition duration-300 ease-out transform"
        enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
        leave-active-class="transition duration-100 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-if="show"
          class="max-w-sm w-full bg-white dark:bg-[#2f2e39] shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden"
        >
          <div class="p-4">
            <div class="flex items-start">
              <div class="flex-shrink-0">
                <CheckCircleIcon
                  v-if="type === 'success'"
                  class="w-6 h-6 text-green-400"
                  aria-hidden="true"
                />
                <XCircleIcon
                  v-if="type === 'error'"
                  class="w-6 h-6 text-fire"
                  aria-hidden="true"
                />
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-base font-medium text-gray-900 dark:text-white">
                  {{ message }}
                </p>
                <p
                  v-if="info.length > 0"
                  class="mt-1 text-sm text-gray-500 dark:text-white"
                >
                  {{ info }}
                </p>
              </div>
              <div class="flex flex-shrink-0 ml-4">
                <button
                  @click="show = !show"
                  class="inline-flex text-white hover:text-fire font-bold outline transition-all text-sm justify-center trans items-center bg-[#dedede] dark:bg-[#000000] w-[24px] h-[24px] rounded-full"
                >
                  X
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { CheckCircleIcon, XCircleIcon } from "@heroicons/vue/outline";
import { XIcon } from "@heroicons/vue/solid";
import { ref } from "vue";

export default {
  name: "Notifications",
  props: {
    message: {
      type: String,
      default: "",
    },
    info: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "success",
    },
  },
  components: {
    XCircleIcon,
    CheckCircleIcon,
    XIcon,
  },
  setup() {
    const show = ref(true);

    return {
      show,
    };
  },
};
</script>
